const constants = {
    API: {
        TIMEOUT: 2000,
    },
    IMAGE_TYPES: {
        MODEL: 'model',
        PRODUCT: 'stilllife',
    },
    COOKIE_NAME: 'hm-reco-cookie',
    PRA: [
        {
            ID: 'PRA2',
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'PRA2',
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'PRA20',
            API: {
                PATH: '/recos/v1/{locale}/articles',
            },
            SOURCE: 'haal',
            TRACKING: {
                IMPRESSION: 'PRA_CAROUSEL_VIEW',
                IMPRESSION_CLICK: 'PRA_CAROUSEL_VIEW',
                CLICK: 'PRA_CAROUSEL_CLICK',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA21',
            API: {
                PATH: '/recos/v1/{locale}/articles',
            },
            SOURCE: 'haal',
            TRACKING: {
                IMPRESSION: 'PRA_CAROUSEL_VIEW',
                IMPRESSION_CLICK: 'PRA_CAROUSEL_VIEW',
                CLICK: 'PRA_CAROUSEL_CLICK',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'SWG',
            PANEL_ID: ['PRA_STYLE_WITH_GROUP', 'pdp_pra_style_with'],
            TRACKING_ID: 'style_with',
            CACHE_ID: 'praPDPCache',
            API: {
                PATH: '/pra/panel/product-detail-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'SWG',
            PANEL_ID: 'PRA_STYLE_WITH_GROUP',
            TRACKING_ID: 'style_with',
            CACHE_ID: 'praPDPCache',
            API: {
                PATH: '/pra/panel/product-detail-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'PRA1',
            PANEL_ID: ['PRA1', 'pdp_pra_alternatives'],
            CACHE_ID: 'praPDPCache',
            API: {
                PATH: '/pra/panel/product-detail-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'PRA1',
            PANEL_ID: 'PRA1',
            CACHE_ID: 'praPDPCache',
            API: {
                PATH: '/pra/panel/product-detail-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
            LAZYLOAD_IMAGES: true,
        },
        {
            ID: 'PRA3',
            PANEL_ID: 'PRA3',
            API: {
                PATH: '',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 6,
                xlarge: 6,
                xxl: 6,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA3',
            PANEL_ID: 'PRA3',
            API: {
                PATH: '',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 6,
                xlarge: 6,
                xxl: 6,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
        },
        {
            ID: 'PRA4',
            PANEL_ID: 'PRA4',
            API: {
                PATH: '',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 6,
                xlarge: 6,
                xxl: 6,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA4',
            PANEL_ID: 'PRA4',
            API: {
                PATH: '',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 6,
                xlarge: 6,
                xxl: 6,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
        },
        {
            ID: 'PRA6',
            API: {
                PATH: '/pra/panel/sub-department-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA6',
            API: {
                PATH: '/pra/panel/sub-department-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
        },
        {
            ID: 'PRA11',
            API: {
                PATH: '/pra/panel/sale-department-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA10',
            API: {
                PATH: '/pra/panel/pra10',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA10',
            API: {
                PATH: '/pra/panel/pra10',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'northstar',
        },
        {
            ID: 'SWG',
            API: {
                PATH: '/{locale}/pra/articles/v2/byids',
            },
            SOURCE: 'default',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 4,
                xlarge: 4,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'cos',
            RESOLVER: {
                HEIGHT: '3',
                WIDTH: '2',
            },
        },
        {
            ID: 'PRA15',
            API: {
                PATH: '/pra/panel/v2/recently-viewed',
                VERSION: 2,
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'imp_visible',
                IMPRESSION_CLICK: 'imp_visible_click',
                CLICK: 'product_click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'hm',
        },
        {
            ID: 'PRA1',
            PANEL_ID: 'PRA1_DEFAULT',
            CACHE_ID: '',
            API: {
                PATH: '/pra/panel/product-detail-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 3,
            },
            THRESHOLD: 0.1,
            BRAND: 'otherstories',
            HEADING_SIZE: 'medium',
            DESCRIPTION_SIZE: 'small',
            PRODUCT_TITLE_TRUNCATE: true,
            RESOLVER: {
                HEIGHT: '7',
                WIDTH: '5',
            },
            CENTER_ALIGNED: true,
        },
        {
            ID: 'PRA3',
            PANEL_ID: 'PRA3',
            CACHE_ID: '',
            API: {
                PATH: '/pra/panel/shopping-bag-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 3,
            },
            THRESHOLD: 0.1,
            BRAND: 'otherstories',
            HEADING_SIZE: 'medium',
            DESCRIPTION_SIZE: 'small',
            PRODUCT_TITLE_TRUNCATE: true,
            RESOLVER: {
                HEIGHT: '7',
                WIDTH: '5',
            },
        },
        {
            ID: 'PRA4',
            PANEL_ID: 'PRA4',
            CACHE_ID: '',
            API: {
                PATH: '/pra/panel/shopping-bag-page',
            },
            SOURCE: 'e-sales',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 3,
            },
            THRESHOLD: 0.1,
            BRAND: 'otherstories',
            HEADING_SIZE: 'medium',
            DESCRIPTION_SIZE: 'small',
            PRODUCT_TITLE_TRUNCATE: true,
            RESOLVER: {
                HEIGHT: '7',
                WIDTH: '5',
            },
        },
        {
            ID: 'SWG',
            API: {
                PATH: '/{locale}/pra/articles/v2/byids',
            },
            SOURCE: 'default',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 2,
                xlarge: 3,
                xxl: 3,
            },
            THRESHOLD: 0.1,
            BRAND: 'otherstories',
            HEADING_SIZE: 'medium',
            DESCRIPTION_SIZE: 'small',
            PRODUCT_TITLE_TRUNCATE: true,
            RESOLVER: {
                HEIGHT: '7',
                WIDTH: '5',
            },
            CENTER_ALIGNED: true,
        },
        {
            ID: 'SWG',
            API: {
                PATH: '/{locale}/pra/articles/v2/byids',
            },
            SOURCE: 'default',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 4,
                xlarge: 4,
                xxl: 4,
            },
            THRESHOLD: 0.1,
            BRAND: 'arket',
            RESOLVER: {
                HEIGHT: '3',
                WIDTH: '2',
            },
            CENTER_ALIGNED: true,
        },
        {
            ID: 'SWG',
            API: {
                PATH: '/{locale}/pra/articles/v2/byids',
            },
            SOURCE: 'default',
            TRACKING: {
                IMPRESSION: 'Impression',
                IMPRESSION_CLICK: 'Impression',
                CLICK: 'click',
            },
            NUM_OF_ITEMS_PER_SLIDE: {
                xsmall: 2,
                small: 2,
                medium: 2,
                large: 5,
                xlarge: 6,
                xxl: 6,
            },
            THRESHOLD: 0.1,
            BRAND: 'monki',
            RESOLVER: {
                HEIGHT: '3',
                WIDTH: '2',
            },
            CENTER_ALIGNED: true,
        },
    ],
};
export var PraIds;
(function (PraIds) {
    PraIds["SWG"] = "SWG";
    PraIds["PRA1"] = "PRA1";
    PraIds["PRA2"] = "PRA2";
    PraIds["PRA3"] = "PRA3";
    PraIds["PRA4"] = "PRA4";
    PraIds["PRA6"] = "PRA6";
    PraIds["PRA10"] = "PRA10";
    PraIds["PRA11"] = "PRA11";
    PraIds["PRA15"] = "PRA15";
    PraIds["PRA20"] = "PRA20";
    PraIds["PRA21"] = "PRA21";
})(PraIds || (PraIds = {}));
export var InternalBrandIds;
(function (InternalBrandIds) {
    InternalBrandIds["COS"] = "cos";
    InternalBrandIds["HM"] = "hm";
    InternalBrandIds["STORIES"] = "otherstories";
    InternalBrandIds["Northstar"] = "northstar";
    InternalBrandIds["ARKET"] = "arket";
    InternalBrandIds["MONKI"] = "monki";
})(InternalBrandIds || (InternalBrandIds = {}));
export default constants;
//# sourceMappingURL=constants.js.map